module.exports = __webpack_public_path__ + "img/mask.d26199a3.gif";